/** @format */

/**
 * Internal dependencies.
 */
import actions from './actions';
import { localizeDate, CONVERT_DIRECTIONS } from '../../includes/date-utils';
import { DEFAULT_PAGE_SIZE } from '../../includes/misc-utils';

/**
 * External dependencies.
 */
import { addQueryArgs } from '@wordpress/url';
import { pickBy, identity } from 'lodash';

/*
 * Generate list of days in query range with unavailable days removed.
 */
function processAvailability( availabilityData ) {
	const mapper = ( src ) => {
		src.productId = src.product_id;
		src.durationUnit = src.duration_unit;
		delete src.product_id;
		delete src.duration_unit;
		src.serverDate = src.date;
		src.date = localizeDate( src.date, CONVERT_DIRECTIONS.SERVER_TO_LOCAL );
		return src;
	};

	return availabilityData.map( mapper );
}

export default {
	* getAvailability( query ) {
		const {
			minDate,
			maxDate,
			page,
			productIds,
			categoryIds,
			resourceIds,
			pageSize = DEFAULT_PAGE_SIZE,
		} = query;

		const queryArgs = {
			product_ids: productIds,
			category_ids: categoryIds,
			resource_ids: resourceIds,
			min_date: minDate ? encodeURIComponent( localizeDate( minDate, CONVERT_DIRECTIONS.LOCAL_TO_SERVER ) ) : minDate,
			max_date: maxDate ? encodeURIComponent( localizeDate( maxDate, CONVERT_DIRECTIONS.LOCAL_TO_SERVER ) ) : maxDate,
			page: page,
			limit: pageSize,
			get_past_times: true,
		};

		const path = addQueryArgs(
			'/wc-bookings/v1/products/slots',
			pickBy( queryArgs, identity )
		);

		try {
			const availabilityData = yield actions.fetchFromAPI( { path: path } );
			const { records, count } = availabilityData;
			const availability = processAvailability( records );
			return actions.setAvailability( availability, count, query );
		} catch ( error ) {
			return actions.setAvailabilityError( query );
		}
	},
};
